import { Link } from 'react-router-dom';
import GraphicPackingConst from '../graphic-packing-const';


const GraphicPackingLinkField = ({ id, title }) => {

    return (
        <Link
            to={ {
                pathname: `${ GraphicPackingConst.basePath }/${ id }`,
                state: {
                    breadcrumbSlug: {
                        id,
                        label: title
                    }
                }
            } }
        >
            { title }
        </Link>
    );
};

export default GraphicPackingLinkField;

